export default {
  All: 'All',
  Rented: 'Rented',
  Idle: 'Idle',
  meau: {
    back: 'Вернуться на официальный сайт',
    nav1: 'Соревнование Орион',
    nav2: 'Режим долгосрочной аренды',
    nav3: 'Режим краткосрочной аренды',
    nav4: 'Список устройств',
  },
  footer: {
    link: 'Узнать больше',
    community: 'Следите за сообществом',
    tip: 'Примечание: Сообщество включает Twitter, Telegram, Reddit, Medium, Discord, TikTok, YouTube',
  },

  home: {
    title1: 'Orion',
    title2: 'Соревнование по вычислительной мощности GPU',
    text: 'Конкурс вычислительной мощности GPU Orion по протоколу DeepLink — это важное соревнование, направленное на стимулирование активного участия майнеров в тестировании сети DeepLink. Этот конкурс является ключевым подготовительным этапом перед официальным запуском DeepLink, крупнейшей в мире платформы облачного игрового протокола, обеспечивая прочную техническую основу и эффективную вычислительную поддержку для будущих пользователей по всему миру',
    text1: 'Текущее общее количество GPU в сети DeepLink составляет {gpu_num}',
    text2: 'Соревнование началось, и как только количество GPU достигнет стандарта, начнутся награды!',
    btn_text1: 'Соревнование в режиме долгосрочной аренды - Завершилось',
    btn_title1: 'Текущий {long_term} GPUs',
    btn_text2: 'Соревнование в режиме краткосрочной аренды - Этап 4',

    btn_title2: 'Текущий {short_term} GPUs',
    cont2_text1:
      'Общая награда в токенах для соревнования по вычислительной мощности Orion составляет 3 миллиарда, из которых 2 миллиарда DLC предназначены для режима долгосрочной аренды и 1 миллиард DLC для режима краткосрочной аренды. Соревнование длится 180 дней и делится на три раунда, каждый из которых длится 60 дней с интервалами от 5 до 10 дней.',
    cont2_btn1: 'Режим долгосрочной аренды',
    cont2_btn2: 'Режим краткосрочной аренды',
    cont3: {
      text1: 'Общая вычислительная \n мощность',
      text2: 'Общее количество \n GPU',
      text3: 'Общее количество \n вычислительных пулов',
      text4: 'Процент аренды \n GPU',
      text5: 'Всего наград DLC',
      text6: 'Количество \n уничтоженных DLC',
      text7: 'Количество заложенных \n для майнеров DLC',
      text8: 'Количество онлайн-GPU',
      text9: 'Уровень аренды онлайн-GPU',
    },
    cont4: {
      li1: 'Рейтинг соревнования',
      li2: 'Имя майнера',
      li3: 'Вычислительная мощность',
      li4: 'Количество GPU',
      li5: 'Процент аренды',
      li6: 'Количество аренд',
      li7: 'Разблокированные награды',
      li8: 'Общее количество наград',
      li9: 'Количество онлайн-GPU',
      li10: 'Уровень аренды онлайн-GPU',
    },
  },
  long_rule: {
    title: 'Правила соревнования в режиме долгосрочной аренды',
    text1: 'Текущее общее количество GPU в режиме долгосрочной аренды в сети DeepLink составляет {long_num}',
    text2:
      'Во время соревнования майнеры могут получить общую награду в размере 2 миллиардов DLC, и 100% арендной платы DLC, оплаченной пользователями, будет сожжено',
    competition_phase_two_in_progress: 'Второй этап соревнования продолжается',
    cont2: {
      title: '1. Правила участия',
      text1_1:
        'Майнеры, участвующие в соревновании по вычислительной мощности Orion, должны владеть узлом NFT ( узнать больше об узле: ',
      text1_2:
        '). В течение соревнования одна машина GPU может иметь несколько узлов, и количество наградных токенов умножается на количество узлов. Максимальное количество узлов NFT на машину — 20.',
      text2_1:
        'Минимальные требования к параметрам сервера GPU: \n Сервер вычислительной мощности должен соответствовать минимальным требованиям \n для прохождения проверки валидатора и выхода в сеть, иначе он не сможет получать доход.',
      text3_1: 'GPU',
      text3_2: 'Должна быть графическая карта серии Nvidia; модели серий 20, 30, 40 или 50',
      text4_1: 'Память',
      text4_2: 'Минимальное требование — 16G на карту, рекомендуется 32G',
      text5_1: 'CPU',
      text5_2:
        'Должен соответствовать требованиям облачного гейминга: Intel/AMD, основная частота 3,0 ГГц или выше, частота турбо — выше 3,5 ГГц; каждый GPU требует отдельного процессора, и он должен быть способен плавно запускать Black Myth: Wukong, например, Intel 10-го поколения и выше, AMD 5600 и выше',
      text6_1: 'Жесткий диск',
      text6_2:
        'Системный диск должен быть более 100G SSD, а диск данных — более 3T SSD, или использовать бездисковую систему',
      text7_1: 'Расположение',
      text7_2:
        'Рекомендуется размещать машину в дата-центре IDC, чтобы избежать штрафов из-за нестабильной сети и электричества',
      text8_1: 'Сетевой канал',
      text8_2: 'Рекомендуется, чтобы каждая машина GPU имела как минимум 10M пропускной способности на вход',
    },
    cont3: {
      title: '2. Правила расчета вычислительной мощности',
      text: 'Арендная плата за пользовательские терминалы во всей экосистеме единообразно основана на системе ценообразования вычислительной мощности. Доход от аренды DLC составляет 0,6 USD/C/месяц. Модель расчета выглядит следующим образом: Вычислительная мощность всей машины = (25 * количество карт + память/3,5 + (√(количество ядер CUDA) * √(память/10)) * количество GPU), когда коэффициент местности равен 1, значение вычислительной мощности будет следующим:',
      li1: 'Тип GPU',
      li2: 'CUDA ядра',
      li3: 'Память',
      li4: 'Количество GPU',
      li5: 'Память (G)',
      li6: 'Вычислительная мощность всей машины (C)',
      li7: 'Аренда всей машины (USD)',
      li8: 'Ставка аренды за карту в месяц (USD)',
    },
    cont4: {
      title: '3. Региональные коэффициенты',
      li1: 'Регион',
      li2: 'Коэффициент',
      li_text1: 'Континентальный Китай',
      li_text2: 'Северная Америка',
      li_text3: 'Южная Америка',
      li_text4: 'Европа',
      li_text5: 'Ближний Восток',
      li_text6: 'Южная Корея',
      li_text7: 'Япония',
      li_text8: 'Тайвань, Китай',
      li_text9: 'Гонконг и Макао, Китай',
      li_text10: 'Малайзия',
      li_text11: 'Индонезия',
      li_text12: 'Сингапур',
      li_text13: 'Вьетнам',
      text1:
        'Формула расчета вычислительной мощности машины: (25 * количество карт + память/3,5 + (√(количество ядер CUDA) * √(память/10)) * количество GPU) * коэффициент большого модели',
      text2: 'Модель машины:',
      text3: 'Количество GPU:',
      text4: 'Размер памяти:',
      text5: 'Регион:',
      text6: 'Пожалуйста, выберите',
      text7: 'Текущее значение вычислительной мощности машины: {total}',
    },
    cont5: {
      title:
        '4. Механизм Вознаграждений (На основе совместимого с EVM DLC на публичной цепи DBC AI, адрес браузера: https://test.dbcscan.io/)',
      text1:
        'Общая сумма токенов для вознаграждения GPU машин в режиме долгосрочной аренды IDC в соревновании по вычислительной мощности Orion составляет 2 миллиарда и длится 180 дней. Соревнование делится на 3 этапа с интервалом в 5-10 дней между каждым этапом.',
      text2:
        'Соревнование 1: Соревнование официально начнется только тогда, когда количество GPU каждого типа достигнет {n_gpu1}.',
      text3:
        '60 дней, 6 миллионов токенов в день, 10% получаются сразу, 90% разблокируются в течение 180 дней, с ежедневной разблокировкой 0,5%.',
      text4:
        'Соревнование 2: Соревнование официально начнется только тогда, когда количество GPU каждого типа достигнет {n_gpu2}.',
      text5:
        '60 дней, 8 миллионов токенов в день, 10% получаются сразу, 90% разблокируются в течение 180 дней, с ежедневной разблокировкой 0,5%.',
      text6:
        'Соревнование 3: Соревнование официально начнется только тогда, когда количество GPU каждого типа достигнет {n_gpu3}.',
      text7:
        '60 дней, 19,33 миллиона токенов в день, 10% получаются сразу, 90% разблокируются в течение 180 дней, с ежедневной разблокировкой 0,5%.',
      text8: 'После листинга на бирже тестовые токены можно обменять на токены основной сети в соотношении 1:1.',
      text9: 'DeepLink использует нелинейный алгоритм вознаграждений.',
      text10:
        'В данной системе общее количество токенов для ежедневного вознаграждения фиксировано. Вознаграждение, которое получает машина, зависит от её вычислительной мощности X, эффективного времени майнинга Y и количества заложенных токенов. Чем больше заложено токенов, тем выше вознаграждение, однако, оно не следует линейной зависимости. Базовое вознаграждение для 0-10,000 токенов одинаковое, но для суммы более 10,000 токенов вознаграждение рассчитывается на основе функции. Если машина находится в аренде, её вычислительная мощность увеличивается на 30%.',
      text11: 'Формула расчета вознаграждения:',
      text12: 'R: Ежедневное общее количество токенов вознаграждения (фиксированное значение)',
      text13: 'Количество заложенных токенов для машины i',
      text14: 'Вычислительная мощность машины i',
      text15: 'Эффективное время майнинга машины i',
      text16: '',
      title1: 'Количество залога:',
      text1_1: '1) Можно выбрать любое количество заложенных токенов или не делать залога.',
      text1_2:
        '2) Для количества залога от 0 до 10,000 вознаграждение одинаково; для суммы свыше 10,000 вознаграждение растёт нелинейно.',
      text1_3:
        '3) Когда сумма залога меньше 10,000, каждая выплата вознаграждения будет сначала увеличивать залог, пока не достигнет 10,000.',
      text1_4:
        '4) Вознаграждение за 100,000 токенов составляет 1.23026 от вознаграждения за залог 10,000 токенов, что примерно на 23.03% больше. За 1,000,000 токенов вознаграждение составляет 1.46052, что примерно на 46.05% больше. За 10,000,000 токенов — 1.69078 или около 69.08%, и за 100,000,000 токенов — 1.92103, что примерно на 92.10% больше.',
      title2: 'Изъятие вознаграждения:',
      text2_1:
        'Вознаграждение можно изымать каждые 24 часа. При каждом изъятии 10% от новых наград доступны немедленно, а 90% блокируются на 180 дней. Заблокированная часть высвобождается на 0.5% при каждом изъятии, а через 180 дней доступна полностью.',
      block_title1: 'Особое Внимание:',
      block_text1_1: 'Режим долгосрочной аренды требует сначала добавить GPU машину в сеть DBC. Справочный документ:',
      block_text1_2:
        '. Затем майнеры должны самостоятельно арендовать машину, прежде чем она сможет присоединиться к сети DLC, что позволит получать доход как в DBC, так и в DLC. Доход в DBC после присоединения к сети DBC = Вознаграждения в DBC - 30% арендной платы.',
      block_title2: 'Формула Расчета Ежедневного Дохода в DBC для Машины:',
      block_text2:
        'Производительность всей машины / общая производительность сети * 547,945 * цена DBC * региональный коэффициент * 1,3 (производительность увеличивается на 30% при аренде) - производительность всей машины * региональный коэффициент * 0,01693 * 30% (ежедневный доход на единицу производительности составляет 0,01693 USD).',
      text3_13:
        'Текущий ежедневный доход: {usdt1} USD эквивалент в DBC = Вознаграждения на цепи: {dbc} DBC (эквивалент {usdt2} USD при текущей цене DBC {dbc_price} USD) - 30% арендной платы: {usdt3} USD эквивалент в DBC.',
      title4: 'Формула Расчета Ежедневного Дохода в DLC для Машины: DLC рассчитывается по цене {price} USD.',
      text4_1: 'Модель GPU:',
      text4_2: 'Объем памяти:',
      text4_3: 'Количество NFT узлов:',
      text4_4: 'Регион:',
      text4_5: 'Сумма стейкованных DLC:',
      text4_6: 'Этап соревнования:',
      text4_6_1: 'Этап 1: 6 миллионов DLC в день.',
      text4_6_2: 'Этап 2: 8 миллионов DLC в день.',
      text4_6_3: 'Этап 3: 19,33 миллиона DLC в день.',
      text4_7: 'Общее количество участвующих GPU:',
      text4_8:
        '(Общее количество GPU рассчитывается на основе модели 4060, 32 ГБ, в среднем с 10 NFT и средней ставкой в 100 000 токенов)',
      title5: 'Вознаграждения на цепи: {dlc_num} DLC (эквивалент {usdt_num} USD при текущей цене DLC {price} USD).',
      req_title1: '5. Механизм Сообщения и Проверки (На основе EVM-совместимого DLC в публичной цепи DBC AI)',
      req_text1:
        'Пользователи, арендующие машины DLC, могут отправлять сообщения в любое время. Для начала сообщения требуется депозит в размере 10 000 DLC. При отправке сообщения информация попадает в процесс валидации проверяющего DBC.',
      req_title2: '6. Механизм Наказания (На основе EVM-совместимого DLC в публичной цепи DBC AI)',
      req_text2:
        'После проверки сообщения DLC, если при проверке есть проблема, согласно правилам будет вычтено количество стейкованных токенов DBC, при этом максимум будет вычтено 10 000 DLC токенов. Эти стейкованные токены будут вознаграждены пользователю, отправившему сообщение.',
      req_title3: '7. Механизм Оплаты и Сжигания (На основе EVM-совместимого DLC в публичной цепи DBC AI)',
      req_text3:
        'Пользователи оплачивают DLC (цены на GPU в сети DLC на 20% выше, чем в сети DBC), чтобы получить право аренды машины. Оплаченный пользователями DLC будет полностью сожжен в смарт-контракте, и каждую оплату и запись сжигания можно будет проверить.',
    },
  },
  short_rule: {
    title: 'Правила Конкурса в Режиме Краткосрочной Аренды',
    text1: 'Текущее количество GPU в режиме краткосрочной аренды в сети DeepLink составляет {short_num}.',
    text2:
      'В период конкурса майнеры могут получить общий приз в размере 1 миллиарда DLC, а арендные сборы DLC, уплаченные пользователями, будут сожжены на 100%.',
    competition_phase_two_in_progress: 'Четвёртый этап соревнования продолжается',
    cont2: {
      title: '1. Правила Участия',
      text1_1:
        'Майнеры, участвующие в соревновании Orion по вычислительной мощности, должны владеть узлом NFT (Подробная информация об узлах:',
      text1_2:
        '). В течение соревнования одна GPU-машина может удерживать несколько узлов, и количество наградных токенов пропорционально количеству узлов. Максимальное количество узлов NFT, которое может удерживать одна машина, составляет 20.',
      text2_1:
        'Минимальные требования к параметрам GPU-сервера: \n Параметры сервера вычислительной мощности должны соответствовать минимальным требованиям.',
      text3_1: 'GPU',
      text3_2: 'Должна быть видеокарта серии Nvidia; поддерживаемые модели включают серии 20, 30, 40 и 50.',
      text4_1: 'Память',
      text4_2: 'Минимальное требование к памяти - 16 ГБ на карту, рекомендуется 32 ГБ.',
      text5_1: 'CPU',
      text5_2:
        "Должен соответствовать требованиям облачных игр: Intel/AMD с базовой частотой 3,0 ГГц или частотой Turbo Boost не менее 3,5 ГГц; для каждой GPU требуется отдельный CPU, способный плавно запускать игру 'Black Myth: Wukong'. Например, Intel 10-го поколения и выше, AMD 5600 и выше.",
      text6_1: 'Жесткий Диск',
      text6_2: 'Системный диск 2T SSD или больше, диск данных 1T или больше',
      text7_1: 'Расположение',
      text7_2: 'Машину можно разместить дома.',
      text8_1: 'Пропускная Способность Сети:',
      text8_2: 'Каждая GPU-машина должна иметь не менее 10 Мбит/с исходящего трафика.',
    },
    cont3: {
      title: '2. Правила Расчета Вычислительной Мощности',
      text: 'Во всей экосистеме арендные ставки для пользователей единообразно основаны на системе ценообразования вычислительной мощности. Доход от аренды DLC составляет 0,508 USD/C/месяц. Модель расчета выглядит следующим образом: Общая вычислительная мощность машины = (25 * количество карт + память/3,5 + (√(количество ядер CUDA) * √(видеопамять/10)) * количество графических карт).',
    },
    cont4: {
      title: '3. Региональные коэффициенты',
      li1: 'Регион',
      li2: 'Коэффициент',
      li_text1: 'Континентальный Китай',
      li_text2: 'Северная Америка',
      li_text3: 'Южная Америка',
      li_text4: 'Европа',
      li_text5: 'Ближний Восток',
      li_text6: 'Южная Корея',
      li_text7: 'Япония',
      li_text8: 'Тайвань, Китай',
      li_text9: 'Гонконг и Макао, Китай',
      li_text10: 'Малайзия',
      li_text11: 'Индонезия',
      li_text12: 'Сингапур',
      li_text13: 'Вьетнам',
      text1:
        'Формула расчета вычислительной мощности машины: (25 * количество карт + память/3,5 + (√(количество ядер CUDA) * √(память/10)) * количество GPU) * региональный коэффициент * коэффициент большого модели',
      text2: 'Модель машины:',
      text3: 'Количество GPU:',
      text4: 'Размер памяти:',
      text5: 'Регион:',
      text6: 'Пожалуйста, выберите',
      text7: 'Текущее значение вычислительной мощности машины: {total}',
    },
    cont5: {
      title:
        '4. Механизм Вознаграждения (На основе EVM-совместимого DLC публичной цепи DBC AI, адрес браузера: https://test.dbcscan.io/)',
      text1:
        'Общая награда в токенах для индивидуальных машин GPU краткосрочной аренды в соревновании Orion составляет 1 миллиард, продолжительность 180 дней. Соревнование делится на 3 этапа, с интервалом 5-10 дней между каждым.',
      text2:
        'Этап 1 соревнования: Соревнование официально начнется только тогда, когда количество каждого типа GPU достигнет {n_gpu1}.',
      text3:
        '60 дней, 3 миллиона токенов в день, 10% разблокировано сразу, 90% разблокировано в течение 180 дней, с ежедневным разблокированием 0,5%.',
      text4:
        'Этап 2 соревнования: Соревнование официально начнется только тогда, когда количество каждого типа GPU достигнет {n_gpu2}.',
      text5:
        '60 дней, 4 миллиона токенов в день, 10% разблокировано сразу, 90% разблокировано в течение 180 дней, с ежедневным разблокированием 0,5%.',
      text6:
        'Этап 3 соревнования: Соревнование официально начнется только тогда, когда количество каждого типа GPU достигнет {n_gpu3}.',
      text7:
        '60 дней, 9,665 миллиона токенов в день, 10% разблокировано сразу, 90% разблокировано в течение 180 дней, с ежедневным разблокированием 0,5%.',
      text8: 'После листинга на бирже тестовые токены можно обменять на токены основной сети в соотношении 1:1.',
      text9: 'DeepLink использует нелинейный алгоритм вознаграждений.',
      text10:
        'В данной системе общее количество токенов для ежедневного вознаграждения фиксировано. Вознаграждение, которое получает машина, зависит от её вычислительной мощности X, эффективного времени майнинга Y и количества заложенных токенов. Чем больше заложено токенов, тем выше вознаграждение, однако, оно не следует линейной зависимости. Базовое вознаграждение для 0-10,000 токенов одинаковое, но для суммы более 10,000 токенов вознаграждение рассчитывается на основе функции. Если машина находится в аренде, её вычислительная мощность увеличивается на 30%.',
      text11: 'Формула расчета вознаграждения:',
      text12: 'R: Общее количество токенов вознаграждения за день (фиксированное значение)',
      text13: 'Количество заложенных токенов для машины i',
      text14: 'Вычислительная мощность машины i',
      text15: 'Эффективное время майнинга машины i',
      text16: '',
      title1: 'Количество залога:',
      text1_1: '1) Можно выбрать любое количество заложенных токенов или не делать залога.',
      text1_2:
        '2) Для количества залога от 0 до 10,000 вознаграждение одинаково; для суммы свыше 10,000 вознаграждение растёт нелинейно.',
      text1_3:
        '3) Когда сумма залога меньше 10,000, каждая выплата вознаграждения будет сначала увеличивать залог, пока не достигнет 10,000.',
      text1_4:
        '4) Вознаграждение за 100,000 токенов составляет 1.23026 от вознаграждения за залог 10,000 токенов, что примерно на 23.03% больше. За 1,000,000 токенов вознаграждение составляет 1.46052, что примерно на 46.05% больше. За 10,000,000 токенов — 1.69078 или около 69.08%, и за 100,000,000 токенов — 1.92103, что примерно на 92.10% больше.',
      title2: 'Изъятие вознаграждения:',
      text2_1_line1:
        'Награды можно выводить в любое время. Если изначально не было заложено DLC или сумма залога менее 10 000, доход будет накапливаться в виде заложенного DLC до достижения 10 000.',
      text2_1_line2: '1) Арендная плата накапливается в качестве залога до достижения 10 000 DLC.',
      text2_1_line3:
        '2) Минимальное время аренды — 2 часа, максимальное не ограничено. Если оставшееся время менее 1 часа, устройство нельзя арендовать и оно не получает онлайн-награду. Майнеры могут увеличить время в любое время, но каждая прибавка должна быть не менее 2 часов.',

      title4: 'Формула расчета дневного дохода DLC: DLC рассчитывается по цене 0,003 USD.',
      text4_8:
        '(Общее количество GPU рассчитывается на основе 4060 32G, с учетом среднего значения 10 NFT и среднего залога в 10 000 токенов)',
      title5:
        'Доходы от наград на цепочке: {dlc_num} DLC (эквивалент {usdt_num} USD при текущей цене DLC {price} USD).',

      req_title1: '5. Механизм Онлайн-Детекции',
      req_text1_1:
        'Машина подчиняется механизму обнаружения публичной цепи DBC AI, которая сообщает информацию в распределенный кластер DBC для определения, находится ли машина в сети. Если она не в сети, онлайн-награды будут вычтены. Если во время использования возникают перебои, DLC будут вычтены у пользователя. Ограничения штрафов:',
      req_text1_2:
        '1) Если монеты не заложены, штрафуется только текущий доход от аренды DLC, максимум до 2 часов арендной платы.',
      req_text1_3: '2) Если DLC заложены, налагается штраф в размере 1 000 DLC.',
      req_text1_4:
        'В машине постоянно работает механизм обнаружения блокчейна DBC AI, который передает информацию в распределенный кластер обнаружения DBC для определения онлайн-статуса машины. Если машина не в сети, онлайн-вознаграждения вычитаются. При прерываниях во время использования у пользователя вычитаются DLC. В настоящее время за каждое прерывание взимается штраф в 1000 DLC, который впоследствии будет динамически изменяться в зависимости от цены DLC',
      req_title2: '6. Правила Сообщения о Машинах',
      req_text2:
        'Если пользователь подозревает, что конфигурация машины может быть мошеннической, он может подать сообщение. В случае успеха все заложенные монеты будут вычтены с машины, а любые вознаграждения будут прекращены.',
      req_title3: 'Заложить 10 000 DLC и отправить информацию о сообщении в цепочку',
      req_text3:
        'Проверяющие, уполномоченные DeepLink, могут участвовать в проверке, с 5 проверяющими, участвующими в каждой проверке, по принципу большинства.',
      text4_6_1: 'Этап 1: 3 миллиона DLC в день.',
      text4_6_2: 'Этап 2: 4 миллиона DLC в день.',
      text4_6_3: 'Этап 3: 9,665 миллиона DLC в день.',
      text4_6_4: 'Этап 4: 9,665 миллиона DLC в день.',
      text4_6_5: 'Этап 5: 9,665 миллиона DLC в день.',
    },
  },
  country: {
    country1: 'Китай',
    country2: 'Северная Америка',
    country3: 'Южная Америка',
    country4: 'Европа',
    country5: 'Ближний Восток',
    country6: 'Южная Корея',
    country7: 'Япония',
    country8: 'Тайвань, Китай',
    country9: 'Гонконг и Макао, Китай',
    country10: 'Малайзия',
    country11: 'Индонезия',
    country12: 'Сингапур',
    country13: 'Вьетнам',
  },
  device: {
    title: 'Список Устройств во Всей Сети',
    title1: 'Просмотрите количество машин, их статус и подробную информацию для различных моделей GPU.',
    table: {
      text1: 'Статус Использования Машин:',
      text2: 'Количество GPU:',
      text3: 'Общее Количество Машин:',
      text4: 'Количество Свободных Машин:',
    },
  },
  machine_id: 'ID машины',
  machine_is_rented: 'Арендована ли',
  machine_rented: 'Арендована',
  machine_idle: 'Свободна',
  machine_is_online: 'В сети ли',
  machine_yes: 'Да',
  machine_no: 'Нет',
  machine_no_data: 'Данные отсутствуют',

  deviceUniqueId: 'Идентификатор машины',
  minerLocation: 'Адрес майнера',
  gpuCount: 'Количество GPU',
  computeCapacity: 'Общая вычислительная мощность',
  isActive: 'Статус онлайн',
  isPledged: 'Статус залога',
  pledgeTotal: 'Общая сумма залога',
  pledgeExpiration: 'Время окончания залога',

  yesOption: 'Да',
  noOption: 'Нет',
  gpuType: 'Тип GPU',
};
